import React from 'react'
import moment from 'moment'
import { component_tool } from '../../../tool';
import HighSet from "@/containers/common/highSet";

let { WizModal } = component_tool;

let componentName = 'cleExam';

const columns = (self) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "考试名称",
      name: "title",
      dataIndex: "title",
      tableItem: {},
      searchItem: {}
    },
    {
      title: "车联试卷编号",
      name: "cleId",
      dataIndex: "cleId",
      searchItem: {},
      tableItem: {
        width: 320,
      },
    },
    {
      title: "考试时间",
      name: "examDate",
      dataIndex: "examDate",
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD',
      }
    },
    {
      title: "开始时间",
      name: "startDate",
      tableItem: {
        width: 200,
      },
    },
    {
      title: "结束时间",
      name: "endDate",
      tableItem: {
        width: 200,
      },
    },
    {
      title: "状态",
      name: "state",
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '已发布' },
        { code: 2, codeName: '已结束' },
        { code: 3, codeName: '已关闭' },
      ],
      searchItem: {
        type: 'select',
      },
      tableItem: {
        width: 120,
      },
    }
  ]
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          collapse: false,
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          dataFormat: (params) => {
            let value = Object.assign({}, params)

            let date = value.examDate;
            if (date && date.length === 2) {
              value.startDate = moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
              value.endDate = moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
            }

            return value
          },
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/cle/examManager/add'
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ['update', 'releaseOrClose', 'exportStudentsAnswers', 'advancedSet'],
        rowOperateView: [
          {
            key: 'advancedSet',
            custom: true,
            params: { children: '高级设置' },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{ record: e.record, bizType: 48 }}
                        changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: false };
              if (record.record && record.record.authState > 0) {
                result.disabled = true
              }
              return result
            },
          },
          {
            key: "update",
            custom: true,
            params: { children: "编辑" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/cle/examManager/upd",
              },
            }
          },
          {
            key: "releaseOrClose",
            custom: true,
            params: { children: "发布" },
            textFormat: {
              recordKey: 'state',
              dirt: { 0: '发布', 1: '关闭', 2: '关闭', 3: '0v0' }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateState"
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `${record['state'] === 0 ? "您确定要发布吗?" : "您确定要取消发布吗?"}`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 0 ? 1 : 3,
                      id: record['id'],
                    })
                  },
                  onCancel() { }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let is = record.state === 3;
              return { disabled: is, hidden: is }
            },
          },
          {
            key: 'exportStudentsAnswers',
            custom: true,
            params: { children: '导出学员答题情况', type: 'export' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "exportStudentsAnswers",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                let cleId = record['cleId'];
                return { cleId }
              }
            }
          }
        ],
        commonOperate: {},
        showAuth: [
          {
            title: "受众",
            text: '查看',
            dataIndex: "authInfo",
            width: 150
          },
        ]
      }
    }
  }
}

const apis = () => {
  return {
    list: {
      path: `${componentName}/pageList`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    updateState: {
      path: `${componentName}/updateState`,
      payload: {
        key: `${componentName}@updateState`,
        apiParams: {}
      }
    },
    exportStudentsAnswers: {
      path: `${componentName}/exportStudentsAnswers`,
      payload: {
        key: `${componentName}@exportStudentsAnswers`,
        apiParams: {},
      }
    }
  }
}

let reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
